export const transformLgParam = params => {
    return Object.entries(params)
        .filter(() => Boolean)
        .map(([_, value]) => value)
        .join(',');
};

export const transformParams = params => {
    return Object.entries(params)
        .filter(([_, value]) => Boolean(value))
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&');
};

export const transformCustomParams = params => {
    return Object.entries(params)
        .filter(() => Boolean)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
};
export const generateUniqueScor = () => {
    const timestamp = Date.now();
    const randomNum = Math.floor(Math.random() * 10000);
    return timestamp + randomNum;
};

export const bufferToHex = buffer => {
    return [...new Uint8Array(buffer)]
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
};

export const getCookie = key => {
    const name = `${key}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return undefined;
};
